const applications = [
  {
    sector: 'Green Steel & Metals',
    icon: 'ri-building-2-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20green%20steel%20manufacturing%20plant%20with%20hydrogen%20direct%20reduction%20furnace%2C%20clean%20industrial%20facility%2C%20minimal%20emissions%2C%20Australian%20heavy%20industry%2C%20professional%20industrial%20photography%2C%20green%20energy%20integration&width=600&height=420&seq=h2-steel-2026&orientation=landscape',
    description: 'Steelmaking produces 7% of global CO₂ emissions. Green hydrogen replaces coking coal in direct reduction iron (DRI) processes, producing green steel with near-zero emissions. Fortescue and BlueScope are already pursuing hydrogen-based steelmaking in Australia.',
    tags: ['Direct Reduction Iron (DRI)', 'Fortescue H2 Steel', 'BlueScope partnership'],
    color: 'border-accent-200 bg-accent-50/20',
    tagColor: 'bg-accent-100 text-accent-800',
  },
  {
    sector: 'Heavy Transport & Logistics',
    icon: 'ri-truck-line',
    image: 'https://readdy.ai/api/search-image?query=Hydrogen%20fuel%20cell%20heavy%20truck%20or%20bus%20refuelling%20at%20hydrogen%20station%20in%20Australia%2C%20clean%20modern%20refuelling%20infrastructure%2C%20zero%20emission%20transport%2C%20professional%20automotive%20photography%2C%20blue%20sky&width=600&height=420&seq=h2-transport-2026&orientation=landscape',
    description: 'Hydrogen fuel cells power heavy trucks, buses, and port equipment without the weight and charging-time limitations of batteries. Hydrogen refuelling takes under 10 minutes and provides 600km+ range — making it ideal for Australian long-haul freight corridors.',
    tags: ['Zero-emission long haul', 'Port logistics', '600km+ range'],
    color: 'border-primary-200 bg-primary-50/20',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    sector: 'Green Ammonia & Fertilisers',
    icon: 'ri-seedling-line',
    image: 'https://readdy.ai/api/search-image?query=Green%20ammonia%20chemical%20production%20plant%20with%20renewable%20energy%20integration%2C%20fertiliser%20production%20facility%2C%20Australian%20landscape%2C%20hydrogen%20storage%20tanks%2C%20clean%20industrial%20photography%2C%20agriculture%20and%20energy%20theme&width=600&height=420&seq=h2-ammonia-2026&orientation=landscape',
    description: "Green ammonia (NH₃) made from green hydrogen and air-captured nitrogen is a carbon-free fertiliser and hydrogen carrier. Australia's existing ammonia export infrastructure positions it perfectly for the Asian green ammonia market — projected to reach $200B by 2050.",
    tags: ['$200B market by 2050', 'Existing export ports', 'Asian demand'],
    color: 'border-secondary-200 bg-secondary-50/20',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    sector: 'Energy Export to Asia',
    icon: 'ri-ship-2-line',
    image: 'https://readdy.ai/api/search-image?query=Large%20hydrogen%20or%20LNG%20export%20terminal%20at%20Australian%20port%20with%20storage%20tanks%20and%20ship%20loading%20infrastructure%2C%20industrial%20port%20facility%2C%20aerial%20view%2C%20professional%20industrial%20photography%2C%20clean%20energy%20export%20concept&width=600&height=420&seq=h2-export-2026&orientation=landscape',
    description: 'Japan, South Korea, Singapore, and Germany have all signed bilateral hydrogen agreements with Australia. Hydrogen can be exported as compressed gas, liquid hydrogen, liquid ammonia, or via methanol carriers. The Hydrogen Energy Supply Chain (HESC) project already completed its first liquid hydrogen export from Victoria to Japan in 2022.',
    tags: ['Japan & Korea agreements', 'HESC project', 'Multiple export formats'],
    color: 'border-accent-200 bg-accent-50/20',
    tagColor: 'bg-accent-100 text-accent-800',
  },
  {
    sector: 'Industrial Heat & Process',
    icon: 'ri-temp-hot-line',
    image: 'https://readdy.ai/api/search-image?query=Industrial%20furnace%20or%20process%20heat%20facility%20switching%20to%20hydrogen%20fuel%2C%20manufacturing%20decarbonisation%2C%20clean%20industrial%20process%2C%20professional%20photography%2C%20heat%20and%20energy%20integration%2C%20modern%20Australian%20factory&width=600&height=420&seq=h2-heat-2026&orientation=landscape',
    description: 'High-temperature industrial processes — cement kilns, glass furnaces, aluminium smelters — cannot easily electrify. Green hydrogen provides the high-temperature heat these industries need while eliminating the carbon emissions from burning gas or coal. Several Australian aluminium and cement facilities are actively piloting hydrogen combustion.',
    tags: ['Cement & glass', 'Aluminium smelting', 'Gas combustion replacement'],
    color: 'border-primary-200 bg-primary-50/20',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    sector: 'Grid Balancing & Storage',
    icon: 'ri-flashlight-line',
    image: 'https://readdy.ai/api/search-image?query=Underground%20hydrogen%20storage%20facility%20with%20large%20tanks%20and%20pipes%2C%20power-to-gas%20installation%2C%20grid%20energy%20storage%20infrastructure%2C%20renewable%20energy%20balancing%2C%20professional%20energy%20storage%20photography%2C%20clean%20modern%20design&width=600&height=420&seq=h2-storage-2026&orientation=landscape',
    description: 'Green hydrogen acts as seasonal storage for the electricity grid — absorbing surplus renewable energy during peak generation periods and releasing it as electricity or gas during low-generation periods. Underground hydrogen storage in salt caverns and depleted gas fields is being actively explored across Australia.',
    tags: ['Seasonal storage', 'Power-to-gas', 'Grid stability'],
    color: 'border-secondary-200 bg-secondary-50/20',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
];

export default function HydrogenApplications() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-50 border border-accent-200/60 mb-5">
            <i className="ri-apps-line text-accent-700 text-sm"></i>
            <span className="text-xs font-semibold text-accent-800 tracking-wide uppercase whitespace-nowrap">Applications</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-foreground-950 mb-4">
            Where Is Green Hydrogen<br className="hidden md:block" /> Being Used in Australia?
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Green hydrogen is unlocking decarbonisation opportunities across sectors that electricity alone cannot address — from heavy industry to transport to energy export.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {applications.map((app) => (
            <article key={app.sector} className={`rounded-2xl border overflow-hidden ${app.color} transition-all duration-200 hover:shadow-sm`}>
              <div className="relative">
                <img
                  src={app.image}
                  alt={`Green hydrogen for ${app.sector} in Australia`}
                  className="w-full h-48 object-cover object-top"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 to-transparent" />
                <div className="absolute bottom-3 left-4 flex items-center gap-2">
                  <div className="w-8 h-8 rounded-lg bg-white/90 flex items-center justify-center">
                    <i className={`${app.icon} text-accent-700 text-sm`}></i>
                  </div>
                  <span className="font-heading text-sm font-bold text-white">{app.sector}</span>
                </div>
              </div>
              <div className="p-5">
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">{app.description}</p>
                <div className="flex flex-wrap gap-2">
                  {app.tags.map((tag) => (
                    <span key={tag} className={`text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap ${app.tagColor}`}>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}